// Phone / tablet / installed-app layout switch.
// The newer, touch-first layout (compact Up next, Ads folders, class day folders,
// separate panels) is for phones, tablets and the home-screen app only; the
// desktop player keeps its classic layout. Adds `is-device` to <html> for CSS.
import { observable, runInAction } from 'mobx'

const queries = ['(pointer: coarse)', '(max-width: 991px)', '(display-mode: standalone)']

function detect () {
  if (typeof window === 'undefined' || !window.matchMedia) return false
  try {
    if (window.navigator.standalone === true) return true
    return queries.some((q) => window.matchMedia(q).matches)
  } catch (e) {
    return false
  }
}

export const deviceState = observable({ isDevice: detect() })

function apply () {
  const on = detect()
  runInAction(() => { deviceState.isDevice = on })
  if (typeof document !== 'undefined') document.documentElement.classList.toggle('is-device', on)
}

if (typeof window !== 'undefined' && window.matchMedia) {
  apply()
  queries.forEach((q) => {
    const mq = window.matchMedia(q)
    if (mq.addEventListener) mq.addEventListener('change', apply)
    else if (mq.addListener) mq.addListener(apply)
  })
}

export const isDevice = () => deviceState.isDevice
